/**
 * Takes in an array of FHIR Location objects and returns an array of location objects.
 * @param {Array<LocationData>} data - the array of location data to convert into location objects.
 * @returns {Array<Location>} - an array of location objects.
 */
export function fLocations(data) {
  const locationArray = [];
  data.forEach((element) => {
    const locationObj = fLocation(element);
    locationArray.push(locationObj);
  });
  return locationArray;
}

/**
 * Formats a location element into a location object.
 * @param {Object} element - The location element to be formatted.
 * @returns {Object} - The formatted location object.
 */
export function fLocation(element) {
  let locationObj = {
    id: element.id,
    name: element.name || '',
    description: element.description || '',
    status: element.status || '',
    mode: element.mode || '',
    partOf: element.partOf ? element.partOf.reference.split('/')[1] : '',
  };

  if (element.operationalStatus?.code) {
    locationObj = {
      ...locationObj,
      operationalStatus: element.operationalStatus.code,
    };
  }

  if (element.physicalType?.coding) {
    if (Array.isArray(element.physicalType.coding)) {
      locationObj = {
        ...locationObj,
        physicalType: element.physicalType.coding[0].code,
      };
    }
  }

  return locationObj;
}
